import { ActionTypes } from "./constants";
import { projects } from "../data/projects";

const portfolioData = projects;

const intitalState = "";

export const themeReducer = (state = intitalState, { type, payload }) => {
  switch (type) {
    case ActionTypes.SET_THEME:
      return payload;

    default:
      return state;
  }
};

export const darkReducer = (state = false, { type, payload }) => {
  switch (type) {
    case ActionTypes.SET_DARK:
      return payload;
    default:
      return state;
  }
};
export const getDataReducer = (state = portfolioData, { type, payload }) => {
  switch (type) {
    case ActionTypes.DATA:
      return payload;
    default:
      return state;
  }
};

export const getFilteredDataReducer = (
  state = portfolioData,
  { type, payload }
) => {
  switch (type) {
    case ActionTypes.FILTERED_DATA:
      return payload;
    default:
      return state;
  }
};

export const getPopular = (state = [], { type, payload }) => {
  switch (type) {
    case ActionTypes.POPULAR:
      return payload;
    default:
      return state;
  }
};

export const getTrending = (state = [], { type, payload }) => {
  switch (type) {
    case ActionTypes.TRENDING:
      return payload;
    default:
      return state;
  }
};

export const getTopStories = (state = [], { type, payload }) => {
  switch (type) {
    case ActionTypes.TOP_STORIES:
      return payload;
    default:
      return state;
  }
};

export const getTopHeadlines = (state = [], { type, payload }) => {
  switch (type) {
    case ActionTypes.TOP_HEADLINES:
      return payload;
    default:
      return state;
  }
};
